import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { StockCategoryService } from '../stock-category.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StockCategoryModel } from './model/stock-category.model';
import { DepartmentService } from '../../../system/department/department.service';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-stock-category',
  templateUrl: './stock-category.component.html',
  styleUrls: ['./stock-category.component.scss'],
  standalone: false
})
export class StockCategoryComponent {

  stockCategoryList: StockCategoryModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;

  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "sic.code",
    },
    {
      title: "Name",
      column: "sic.name",
    },
    {
      title: "Department",
      column: "sic.department_id",
      type: "list",
      values: [],
    },
    {
      title: "Super Category",
      column: "sic.super_category_id",
      type: "list",
      values: [],
    },
  ];
  displayedColumns = ['code', 'name', 'department_id', 'super_category_id', 'action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: StockCategoryModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<StockCategoryModel>(true, []);
  department_id: any;
  super_category_id: any;
  dataSource = new MatTableDataSource(this.stockCategoryList);
  constructor(private breakpointObserver: BreakpointObserver,
    private stockCategoryService: StockCategoryService,
    private departmentService: DepartmentService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private stateManagerService: StateManagerService,
    private router: Router) {

    this.stockCategoryList = [];
  }
  /**
    * initilaize the device model
    */
  //  ngOnInit(): void {
  //   this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
  //     if (state.matches) {
  //       this.isHandset = true;
  //     } else {
  //       this.isHandset = false;
  //     }
  //   });
  //  // this.loadUomList();

  //   this.loadCategoryList();
  //   this.loadDepartmentList();

  //   this.loadData();
  // }


  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.loadCategoryList();
    this.loadDepartmentList();
    this.isLoading = false; // Set to true on page load
    this.IsDownloading = false;

  }
  /** 
  * Set the datasource
  */
  setDataSource(stockCategoryList: StockCategoryModel[]) {
    this.dataSource = new MatTableDataSource(stockCategoryList);
    this.dataSource.sort = this.sort;
  }


  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.isHandset = false;
    }
    this.loadData();

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.stockCategoryList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.stockCategoryList);
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }
  loadDepartmentList(): void {
    const requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: 'code', order: 'asc' }]
      }
    };

    this.departmentService.getDepartmentList(requestData).subscribe({
      next: (response: { status: string; data: { departments: any; }; message: any; }) => {
        if (response.status === 'SUCCESS') {
          this.department_id = response.data.departments;
          this.filter[2].values = this.department_id.map((dept: any) => {
            return { title: dept.name, value: dept.id };
          });
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to load departments.');
      }
    });
  }
  showErrorSnackbar(message: any) {
    throw new Error('Method not implemented.');
  }

  loadCategoryList(): void {
    const requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };

    this.stockCategoryService.getParentCategory(requestData).subscribe({
      next: (response: { status: string; data: { categories: any; }; message: any; }) => {
        if (response.status === 'SUCCESS') {
          this.super_category_id = response.data.categories;
          this.filter[3].values = this.super_category_id.map((cat: any) => {
            return { title: cat.name, value: cat.id };
          });
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to load categories.');
      }
    });
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(stockCategoryInfo: StockCategoryModel): void {
    const stockCategoryId = stockCategoryInfo.id;
    const message = `Are you sure, you want to delete ` + (stockCategoryInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.stockCategoryService.delete(stockCategoryInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + stockCategoryInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.stockCategoryService.getList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.stockCategoryList = response.data.categories;
        console.log(this.stockCategoryList);
        this.setDataSource(this.stockCategoryList);

        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }


  /**
  * On areainfo selected
  * @param areaInfo 
  */
  onRowSelected(stockCategoryInfo: StockCategoryModel): void {
    this.selectedItem = stockCategoryInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(stockCategoryInfo: StockCategoryModel): void {

    this.router.navigate(['product/stock-category-edit', stockCategoryInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new area
   */
  addClicked(): void {

    this.router.navigate(['product/stock-category-edit', 0]);

  }


  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.stockCategoryService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'stockCategory.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }


}










